import React from 'react';
import map from 'lodash/map';
import { channelObjects } from '../../../shared/model/constants/channels';
import { CHANNEL_PROP_TYPES } from '../../../shared/model/types';
import styles from './ChannelTabs.scss';
import Link from '../../../shared/components/Link';
import homepageUrlGenerator from '../../../shared/model/transformers/homepageUrlGenerator';

const ChannelTabs = ({ currentChannel }) => {
  const isActive = url => url === currentChannel.url;

  return (
    <ul className={styles.wrapper}>
      { map(channelObjects, channelObject => (
        <li className={styles.item} key={`channel-tab-${channelObject.url}`}>
          <Link
            className={isActive(channelObject.url) ? styles.tabActive : styles.tab}
            href={homepageUrlGenerator(channelObject)}
            title={channelObject.shortHumanReadable}
            onClick={() => {}}
          >
            {channelObject.shortHumanReadable}
          </Link>
        </li>
      ))}
    </ul>
  );
};

ChannelTabs.propTypes = {
  currentChannel: CHANNEL_PROP_TYPES.isRequired,
};

export default ChannelTabs;
